<script lang="ts" setup>
import { computed } from 'vue';
import { stringify } from 'yaml';
import { LineWrappingMode } from '#layers/ui/public';

const props = defineProps<{
	value: unknown;
}>();

const formattedValue = computed(() => {
	if (typeof props.value === 'string') return props.value;

	return stringify(props.value, { lineWidth: 0 }).trimEnd();
});
</script>

<template>
	<DInputCode
		:model-value="formattedValue"
		code-language="yaml"
		inert
		block
		size="xs"
		variant="subtle"
		class="bg-transparent!"
		:line-wrapping="LineWrappingMode.Off"
		:max-height-before-expand="320"
	/>
</template>
